import "../shared/components/Card";
import "../shared/components/YouTube";
import "../shared/components/PingForm";
import "../shared/components/RepositoryCard";
import "./CardAnimation";
import { HomepageAudio } from "./Audio";
import { requiredElement } from "./Dom";
import { createEasterEggHandler } from "./EasterEggs";
import { initKeyboardLogo } from "./KeyboardLogo";

function main(): void {
	const audio = new HomepageAudio({
		"keydown.mp3": requiredElement<HTMLMetaElement>("keydown-audio").content,
		"keyup.mp3": requiredElement<HTMLMetaElement>("keyup-audio").content,
	});
	initKeyboardLogo(audio, createEasterEggHandler(audio));
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", main, { once: true });
} else {
	main();
}
